import AdminOrganizerTable from './AdminOrganizerTable';
import AddButton from '../../components/Buttons/AddButton';
import ModalCentered from '../../components/ModalCentered';
import { useState, useEffect } from 'react';
import {
  getOrganizers,
  inactivateOrganizer,
  activateOrganizer,
} from '../../api/Admin';
import AddOrganizerModal from './AddOrganizerModal';
import UpdateOrganizerModal from './UpdateOrganizerModal';
import Col from 'react-bootstrap/esm/Col';
import OrganizerCard from './OrganizerCard';
import CustomToast from '../../components/CustomToast';
import Spinner from 'react-bootstrap/esm/Spinner';
import Loading from '../../components/Loading';
import EmptyState from '../../components/EmptyState';

function AdminOrganizer() {
  const [organizerList, setOrganizerList] = useState({});
  const [chosenOrganizer, setChosenOrganizer] = useState();
  const [chosenOrganizerId, setChosenOrganizerId] = useState('');
  const [newOrganizerModalShow, setNewOrganizerModalShow] = useState(false);
  const [updateOrganizerModalShow, setUpdateOrganizerModalShow] =
    useState(false);
  const [activateOrganizerShow, setActivateOrganizerShow] = useState(false);
  const [inactivateOrganizerShow, setInactivateOrganizerShow] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastType, setToastType] = useState();
  const [toastTitle, setToastTitle] = useState();
  const [toastBody, setToastBody] = useState();
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    async function fetchOrganizers() {
      const result = await getOrganizers();
      if (result) {
        setOrganizerList(result.list);
        setLoading(false);
      }
    }

    fetchOrganizers();
  }, [
    newOrganizerModalShow,
    updateOrganizerModalShow,
    activateOrganizerShow,
    inactivateOrganizerShow,
    chosenOrganizerId,
  ]);

  const onInactivateOrganizer = async () => {
    setUpdating(true);
    const result = await inactivateOrganizer(chosenOrganizerId);
    if (result) {
      switch (result.statusCode) {
        case 200:
          setToastType('success');
          setToastTitle('Arrangör inaktiverad');
          setToastBody('Arrangören har blivit inaktiverad');
          break;
        default:
          setToastType('danger');
          setToastTitle('Arrangör ej inaktiverad');
          setToastBody('Arrangören kunde inte inaktiveras');
      }
      setInactivateOrganizerShow(false);
      setShowToast(true);
      setUpdating(false);
      setChosenOrganizerId('');
    }
  };

  const onActivateOrganizer = async () => {
    setUpdating(true);
    const result = await activateOrganizer(chosenOrganizerId);
    if (result) {
      switch (result.statusCode) {
        case 200:
          setToastType('success');
          setToastTitle('Arrangör aktiverad');
          setToastBody('Arrangören har blivit aktiverad');
          break;
        default:
          setToastType('danger');
          setToastTitle('Arrangör ej aktiverad');
          setToastBody('Arrangören kunde inte aktiveras');
      }
      setActivateOrganizerShow(false);
      setShowToast(true);
      setUpdating(false);
      setChosenOrganizerId('');
    }
  };

  const inactivateBtn = (
    <>
      {updating ? (
        <>
          <Spinner
            as='span'
            animation='border'
            size='sm'
            role='status'
            aria-hidden='true'
            className='me-2'
          />
          <span className='visually-hidden'>Loading...</span>
          Inaktivera
        </>
      ) : (
        'Inaktivera'
      )}
    </>
  );

  const activateBtn = (
    <>
      {updating ? (
        <>
          <Spinner
            as='span'
            animation='border'
            size='sm'
            role='status'
            aria-hidden='true'
            className='me-2'
          />
          <span className='visually-hidden'>Loading...</span>
          Aktivera
        </>
      ) : (
        'Aktivera'
      )}
    </>
  );

  return (
    <>
      <AddButton
        text='Ny arrangör'
        onClick={() => setNewOrganizerModalShow(true)}
        className='mb-4 mt-2'
      />

      <hr />

      {loading ? (
        <div className='d-flex justify-content-center align-items-center mt-5 mb-5'>
          <Loading size='100px' text='Laddar arrangörer' />
        </div>
      ) : organizerList && organizerList.length > 0 ? (
        <>
          <Col className='d-none d-xl-flex mt-2'>
            <AdminOrganizerTable
              organizerList={organizerList}
              onActivate={() => setActivateOrganizerShow(true)}
              onInactivate={() => setInactivateOrganizerShow(true)}
              onEdit={() => setUpdateOrganizerModalShow(true)}
              chosenOrganizer={setChosenOrganizer}
              chosenOrganizerId={setChosenOrganizerId}
            />
          </Col>
          <Col className='d-flex flex-column gap-3 d-xl-none mt-2'>
            {organizerList.map((o, index) => {
              return (
                <OrganizerCard
                  key={index}
                  organizer={o}
                  chosenOrganizerId={setChosenOrganizerId}
                  chosenOrganizer={setChosenOrganizer}
                  onActivate={() => setActivateOrganizerShow(true)}
                  onInactivate={() => setInactivateOrganizerShow(true)}
                  onEdit={() => setUpdateOrganizerModalShow(true)}
                />
              );
            })}
          </Col>
        </>
      ) : (
        <EmptyState
          headingText='Inga arrangörer skapade'
          action={
            <AddButton
              text='Skapa arrangör'
              onClick={() => setNewOrganizerModalShow(true)}
              className='mb-4 mt-2'
            />
          }
        />
      )}

      <AddOrganizerModal
        show={newOrganizerModalShow}
        onHide={() => setNewOrganizerModalShow(false)}
        organizers={organizerList}
        setToastType={setToastType}
        setToastTitle={setToastTitle}
        setToastBody={setToastBody}
        setShowToast={setShowToast}
      />
      <UpdateOrganizerModal
        organizer={chosenOrganizer}
        setToastType={setToastType}
        setToastTitle={setToastTitle}
        setToastBody={setToastBody}
        setShowToast={setShowToast}
        show={updateOrganizerModalShow}
        onHide={() => setUpdateOrganizerModalShow(false)}
      />
      <ModalCentered
        header='Inaktivera arrangör'
        body={<span>Är du säker på att du vill inaktivera arrangören?</span>}
        confirmBtnText={inactivateBtn}
        onConfirm={() => {
          onInactivateOrganizer();
        }}
        show={inactivateOrganizerShow}
        onHide={() => setInactivateOrganizerShow(false)}
      />
      <ModalCentered
        header='Aktivera arrangör'
        body={<span>Är du säker på att du vill aktivera arrangören?</span>}
        confirmBtnText={activateBtn}
        onConfirm={() => {
          onActivateOrganizer();
        }}
        show={activateOrganizerShow}
        onHide={() => setActivateOrganizerShow(false)}
      />
      <CustomToast
        type={toastType}
        title={toastTitle}
        body={toastBody}
        show={showToast}
        onClose={() => setShowToast(false)}
      />
    </>
  );
}

export default AdminOrganizer;
